







import Vue from "vue";
import ScrollReveal from "scrollreveal";
import HeaderImg from "@/components/shared/header-img/HeaderImg.vue";
import MainPipeline from "@/components/home-view/main-pipeline/MainPipeline.vue";
import { scrollConfig } from "@/resources/animations/configs.ts";

export default Vue.extend({
  name: "Pipeline",
  components: {
    MainPipeline,
    HeaderImg
  },
  data() {
    return {
      sections: {
        pipeline: "pipeline"
      },
      pipelineHeaderImg: {
        path: "pipeline",
        image: "",
        imageAlt: "pipeline top img"
      }
    };
  },
  created() {
    this.pipelineHeaderContent();
  },
  mounted() {
    window.scrollTo(0, 0);
    this.setRevealAnimation();

    window.addEventListener("resize", () => this.pipelineHeaderContent());
  },
  beforeDestroy() {
    window.removeEventListener("resize", () => this.pipelineHeaderContent());
  },
  methods: {
    setRevealAnimation() {
      Object.entries(this.sections).forEach((section: string[]) => {
        ScrollReveal().reveal(`.${section[1]}`, scrollConfig);
      });
    },
    pipelineHeaderContent() {
      const width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      const desktopViewport = width > 599;
      this.pipelineHeaderImg = {
        ...this.pipelineHeaderImg,
        image: desktopViewport
          ? "desktop_pipeline_top_img.jpg"
          : "mobile_pipeline_top_img.jpg"
      };
    }
  }
});
